import { Button, Modal } from "antd";
import { useState } from "react";
import OpeningRestrictions from "./CashingDocument";
import Heading from "components/Heading/Heading";
import BasicButton from "components/BasicButton/BasicButton";

function ModalCashingDocument() {
  const [openModalOpeningRestrictions, setOpenModalOpeningRestrictions] =
    useState(false);

  return (
    <>
      <Heading name={"مستند صرف"} />
      <BasicButton>
        <Button
          className="w-[150px] h-8"
          type="primary"
          onClick={() => setOpenModalOpeningRestrictions(true)}
        >
          اضافه
        </Button>
      </BasicButton>
      <Modal
        title="اضافه مستند صرف"
        style={{ top: 20 }}
        open={openModalOpeningRestrictions}
        onOk={() => setOpenModalOpeningRestrictions(false)}
        onCancel={() => setOpenModalOpeningRestrictions(false)}
        width={1200}
        footer={false}
      >
        <OpeningRestrictions />
      </Modal>
    </>
  );
}

export default ModalCashingDocument;
